import { motion } from "framer-motion";
import { IMAGES, STATS } from "../lib/constants";
import SectionHeader from "./SectionHeader";

export const About = () => {
    return (
        <section
            id="about"
            className="relative py-24 md:py-40 border-t border-ls-ink/10"
            data-testid="about-section"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20">
                <div className="lg:col-span-5 lg:sticky lg:top-32 self-start">
                    <SectionHeader
                        eyebrow="Über uns"
                        title={
                            <>
                                Gestaltung mit{" "}
                                <em className="italic font-light">Haltung</em>.
                                Beratung mit Tiefe.
                            </>
                        }
                    />
                </div>

                <div className="lg:col-span-7 flex flex-col gap-10">
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.8 }}
                        className="space-y-6 font-sans text-ls-inkSoft text-base md:text-lg leading-relaxed"
                    >
                        <p>
                            LS Design & Consulting ist ein kleines, inhabergeführtes
                            Studio für Webdesign und digitale Beratung. Wir
                            verbinden gestalterische Präzision mit strategischem
                            Denken – für Unternehmen, die Wert auf Qualität,
                            Klarheit und Wirkung legen.
                        </p>
                        <p>
                            Jedes Projekt ist individuell. Wir hören zu,
                            analysieren sorgfältig und entwickeln Lösungen, die
                            zu Ihrem Geschäft passen – nicht zum Trend.
                            Professionalität, Kreativität und echte Kundennähe
                            sind für uns keine Schlagworte, sondern
                            Arbeitsweise.
                        </p>
                    </motion.div>

                    <motion.div
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.9, delay: 0.2 }}
                        className="relative aspect-[16/10] overflow-hidden border border-ls-ink/10"
                    >
                        <img
                            src={IMAGES.about}
                            alt="Studio Eindruck"
                            className="w-full h-full object-cover"
                        />
                    </motion.div>

                    <div className="grid grid-cols-2 gap-6 pt-6 border-t border-ls-ink/10 max-w-md">
                        {STATS.map((s, i) => (
                            <motion.div
                                key={s.label}
                                initial={{ opacity: 0, y: 14 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true }}
                                transition={{
                                    duration: 0.6,
                                    delay: 0.1 + i * 0.08,
                                }}
                                data-testid={`stat-${i}`}
                            >
                                <div className="font-serif text-4xl md:text-5xl text-ls-ink tracking-tight">
                                    {s.value}
                                </div>
                                <div className="text-[10px] uppercase tracking-[0.22em] text-ls-inkSoft mt-2 font-sans">
                                    {s.label}
                                </div>
                            </motion.div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default About;
